<script setup>
import {computed} from 'vue';
import moment from "moment";
import ExtendAutoApprove from "@/components/approval-center/partials/buttons/ExtendAutoApprove.vue";

const props = defineProps({
  approval: {
    type: Object,
    required: true,
  },
  hideApprovalText: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const formattedDate = computed(() => {
  const date = moment(props.approval.auto_approve_at);
  return date.format('DD/MM/YYYY');
});

const daysUntil = computed(() => {
  const targetDate = moment(props.approval.auto_approve_at).startOf('day');

  const today = moment().startOf('day');

  return Math.max(targetDate.diff(today, 'days'), 0);
});
</script>

<template>
  <div class="tw-flex tw-gap-6">
    <div class="tw-text-neutral tw-text-sm tw-flex tw-gap-2 tw-items-center">
      <svg-vue
        class="tw-w-7 tw-h-7"
        icon="icons/warning-thin"
      />
      <span
        v-if="!hideApprovalText"
        class="tw-text-left"
      >
        This will be auto-approved <br>in <strong>{{ daysUntil }} days</strong> ({{ formattedDate }}).
      </span>
    </div>
    <ExtendAutoApprove
      v-if="approval.can_be_extended"
      :approval-id="approval.id"
      :auto-approve-at="approval.auto_approve_at"
    />
  </div>
</template>
